import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/modules/growing-circle/lib/api";
import { useAuth } from "@/modules/growing-circle/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/modules/growing-circle/components/PasswordInput";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (password.length < 8) return toast.error("The password must be at least 8 characters.");
    if (password !== confirm) return toast.error("The passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      await refresh();
      toast.success("Password updated.");
      navigate("/growing-circle/member-area");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background grain flex items-center justify-center px-5">
      <div className="max-w-md w-full bg-card border border-border rounded-3xl p-10 animate-fade-in-up">
        <h1 className="font-heading text-3xl tracking-tight mb-8">Reset your password</h1>
        {!token ? (
          <p className="text-destructive">Invalid link.</p>
        ) : (
          <div className="space-y-5">
            <div>
              <Label>New password</Label>
              <PasswordInput data-testid="reset-password-input" className="mt-2 rounded-xl bg-background" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div>
              <Label>Confirm</Label>
              <PasswordInput data-testid="reset-confirm-input" className="mt-2 rounded-xl bg-background" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            <Button className="btn-gold w-full rounded-full h-12 text-sm font-medium" disabled={loading} onClick={submit} data-testid="reset-submit-btn">
              {loading ? "One moment…" : "Update password"}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
